
import { City } from "@/@types/common";
import { computed, defineComponent, nextTick, ref, watch } from "vue";
import { CitySelect } from "@/components/Common";
import { AnalysisAddress } from "@/api-server/modules/defaultServer";

export default defineComponent({
  name: "editAddress",
  components: {
    CitySelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const defaultProvinceObj = ref<City | null>(null);
    const defaultCityObj = ref<City | null>(null);
    const defaultCountyObj = ref<City | null>(null);
    const editFormData = computed({
      get() {
        return props.formData;
      },
      set(nv: any) {
        emit("update:formData", nv);
      },
    });
    const loading = ref(false);
    const newInfo = ref("");
    // 张三 19343435342 上海市青浦区华新镇2号

    const handleCityChange = (
      provinceObj: any,
      cityObj: any,
      countyObj: any
    ) => {
      if (countyObj) {
        editFormData.value.province = provinceObj.text;
        // editFormData.value.provinceCode = provinceObj.value;
        editFormData.value.city = cityObj.text;
        // editFormData.value.cityCode = cityObj.value;
        editFormData.value.area = countyObj.text;
        // editFormData.value.districtCode = countyObj.value;
      } else {
        editFormData.value.province = "";
        // editFormData.value.provinceCode = "";
        editFormData.value.city = "";
        // editFormData.value.cityCode = "";
        editFormData.value.area = "";
        // editFormData.value.districtCode = "";
      }
    };

    const handleTrim = () => {
      newInfo.value = newInfo.value.trim();
    };
    const handleIdentify = async (addr: string, only: boolean) => {
      if (!addr || !addr.trim()) return;
      loading.value = true;
      const {
        data: { data },
      } = await AnalysisAddress.fetch({
        address: addr.trim(),
      });
      const {
        address = "",
        city = "",
        cityId = "",
        district = "",
        districtId = "",
        name = "",
        phone = "",
        province = "",
        provinceId = "",
      } = data as BUSINESS_SERVE_PLATFORM_PC.AnalysisAddressResponseData;
      provinceId &&
        (defaultProvinceObj.value = { text: province, value: provinceId });
      cityId && (defaultCityObj.value = { text: city, value: cityId });
      districtId &&
        (defaultCountyObj.value = { text: district, value: districtId });

      if (!only) {
        address && (editFormData.value.detailsAddress = address);
        name && (editFormData.value.customerName = name);
        phone && (editFormData.value.customerPhone = phone);
      }

      handleCityChange(
        defaultProvinceObj.value,
        defaultCityObj.value,
        defaultCountyObj.value
      );
      loading.value = false;
    };

    const resetDefault = () => {
      defaultProvinceObj.value = { text: "", value: "" };
      defaultCityObj.value = { text: "", value: "" };
      defaultCountyObj.value = { text: "", value: "" };
      nextTick(() => {
        defaultProvinceObj.value = null;
        defaultCityObj.value = null;
        defaultCountyObj.value = null;
      });
    };

    const handleClear = () => {
      newInfo.value = "";
    };

    watch(
      () => props.visible,
      (visible) => {
        if (visible) {
          handleIdentify(
            props.formData.province + props.formData.city + props.formData.area,
            true
          );
        } else {
          handleClear();
          resetDefault();
        }
      }
    );

    return {
      editFormData,
      defaultProvinceObj,
      defaultCityObj,
      defaultCountyObj,
      newInfo,
      handleCityChange,
      handleTrim,
      handleIdentify,
      handleClear,
      loading,
    };
  },
});
